import { getResourceFromAws } from '@/shared/_api'
export default {
  fetchResource: async ({ commit, dispatch, getters }, resourceInformation) => {
    const { id } = resourceInformation
    if (id > 0) {
      let resourceInStore = getters.resourceIdList.find(el => el && el === id)
      if (!resourceInStore) {
        commit('addResourceId', id)
        if (id) {
          // const url = await getMediaUrl(id)
          // const response = await getUrlResource(url.data[0])
          const response = await getResourceFromAws(id)
          dispatch('generateResource', { id: id, resource: response.data })
        }
      }
    }
  },
  generateResource: ({ commit }, resourceInformation) => {
    const resourceUrl = URL.createObjectURL(resourceInformation.resource)
    commit('addResource', { id: resourceInformation.id, resource: resourceUrl })
  },
  clearStore: ({ commit }) => {
    commit('removeResources')
  },
  removeResource: ({ commit }, id) => {
    commit('removeResource', id)
  }

}
